import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment/moment';

import AppRoutes from '@/routes/Routes';
import { profileSelector } from '@/store/profile/profileSlices';
// import ConfirmEmailAlert from '@/components/shared/ConfirmEmailAlert'; // Removed
import useHealthCheck from '@/hooks/useHealthCheck';
import UIAlert from '@/components/shared/UIAlert';
import { ToastProvider } from '@/components/shared/ToastProvider';

import './App.scss';

moment.locale('en');

function App() {
  const profile = useSelector(profileSelector);
  const { isHealthy, isLoading, error } = useHealthCheck();

  // Removed: Logic for scrolling to alert
  // useEffect(() => {
  //   if (profile && !profile.isEmailConfirmed) {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //   }
  // }, [profile]);

  // Поки йде перевірка стану бекенда, показуємо заглушку
  if (isLoading) {
    return <div className="AppLoading">Checking service availability...</div>;
  }

  // Якщо бекенд недоступний, блокуємо весь додаток і показуємо помилку
  if (!isHealthy) {
    return (
      <div className="App">
        <div className="Overlay" />
        <UIAlert variant="danger" fullWidth>
          <strong>Service Unavailable:</strong> {error}
        </UIAlert>
      </div>
    );
  }

  // Якщо все добре, рендеримо додаток
  return (
    <ToastProvider>
      <div className="App">
        {/* Removed: Conditional rendering of ConfirmEmailAlert */}
        {/* {profile && !profile.isEmailConfirmed && (
          <>
            <div className="Overlay" />
            <ConfirmEmailAlert email={profile.email} />
          </>
        )} */}

        <AppRoutes />
      </div>
    </ToastProvider>
  );
}

export default App;
